const Source = {
    FOURSQUARE: 'foursquare',
    GAIA: 'gaia',
    TRIPOSO: 'triposo',
};

export default Source;
